var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile01SolidStandard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.18754 1.25C4.5782 1.25 3.27288 2.55975 3.27037 4.17704L3.2461 19.8138C3.24358 21.4347 4.55038 22.75 6.16327 22.75H12.9656C13.2232 22.75 13.4702 22.6473 13.6525 22.4645L20.4606 15.6367C20.6434 15.4534 20.7461 15.2045 20.7461 14.945V4.18162C20.7461 2.56253 19.44 1.25 17.8289 1.25H6.18754ZM18.8004 14.5391L12.5634 20.7941V16.0391C12.5634 15.2106 13.235 14.5391 14.0634 14.5391H18.8004ZM7.25 6C7.25 5.58579 7.58579 5.25 8 5.25H16C16.4142 5.25 16.75 5.58579 16.75 6C16.75 6.41421 16.4142 6.75 16 6.75H8C7.58579 6.75 7.25 6.41421 7.25 6ZM8 9.25C7.58579 9.25 7.25 9.58579 7.25 10C7.25 10.4142 7.58579 10.75 8 10.75H12C12.4142 10.75 12.75 10.4142 12.75 10C12.75 9.58579 12.4142 9.25 12 9.25H8Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile01SolidStandard);
export default __webpack_public_path__ + "static/media/file-01-solid-standard.f2fd587aeaa791926997526c918f44fa.svg";
export { ForwardRef as ReactComponent };